import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IPublishedConnectionColumn } from '../types/IPublishedConnectionTable';

export interface IGetPublishedConnectionColumnsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionColumnsResult extends IGetItemsResult {
  publishedConnectionColumns?: IPublishedConnectionColumn[];
}

export class GetPublishedConnectionColumnsRequest extends Request<IGetPublishedConnectionColumnsParams, IGetPublishedConnectionColumnsResult> {
  constructor(params: IGetPublishedConnectionColumnsParams) {
    super('getPublishedConnectionColumns', params);
  }
}
